var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"modal_wrapper"},[_c('div',{staticClass:"todaylowestprice",attrs:{"id":"modal_search"}},[_c(_vm.currentComponent,{tag:"component"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }